import { g } from "../../util/index.ts";
import { isSport } from "../../../common/sportFunctions.ts";
import type { PlayerWithoutKey } from "../../../common/types.ts";

// A club can carry at most this many players on the maximum salary
export const MAX_CONTRACTS_PER_TEAM = 5;

export const isMaxContract = (amount: number) => amount >= g.get("maxContract");

// Whether a club with this roster can sign someone for this amount. The player himself is not counted,
// so re-signing one of the five is always allowed.
export const roomForMaxContract = (
	roster: { pid?: number; contract: { amount: number } }[],
	amount: number,
	pid?: number,
) =>
	!isSport("baseball") ||
	!isMaxContract(amount) ||
	roster.filter((p) => p.pid !== pid && isMaxContract(p.contract.amount))
		.length < MAX_CONTRACTS_PER_TEAM;

// Discount a player good enough for the maximum contract gives a club, for each of his traits it satisfies
export const MAX_CONTRACT_DISCOUNT_PER_TRAIT = 0.125;

// How many of his traits a club satisfies: market and hype (F), winning (W), his own club (L)
export const traitsSatisfied = (
	traits: string[],
	components: {
		marketSize: number;
		hype: number;
		teamPerformance: number;
		loyalty: number;
	},
) =>
	(traits.includes("F") && components.marketSize + components.hype > 0 ? 1 : 0) +
	(traits.includes("W") && components.teamPerformance > 0 ? 1 : 0) +
	(traits.includes("L") && components.loyalty > 0 ? 1 : 0);

// A player posted from Japan or Korea asks at most this share of the maximum for his first MLB contract
export const POSTED_MAX_SHARE = 0.7;

// Cap on what he can ask, or undefined once he has signed his first contract here
export const postedCap = (p: Pick<PlayerWithoutKey, "posted" | "transactions">) =>
	isSport("baseball") &&
	p.posted !== undefined &&
	!(p.transactions ?? []).some((t) => t.type === "freeAgent")
		? g.get("maxContract") * POSTED_MAX_SHARE
		: undefined;
